import { get, del, getToken } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/documents`;

export const list = (wsId, params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`${base(wsId)}${q}`);
};

export const getOne = (wsId, docId) => get(`${base(wsId)}/${docId}`);
export const remove = (wsId, docId) => del(`${base(wsId)}/${docId}`);

export const download = async (wsId, docId, fileName, inline = false) => {
  const headers = {};
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const qs = inline ? '?inline=1' : '';
  const res = await fetch(`/api/v1${base(wsId)}/${docId}/download${qs}`, { headers });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  if (inline) return URL.createObjectURL(blob);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'download';
  a.click();
  URL.revokeObjectURL(url);
};

/* File upload uses multipart/form-data — cannot use JSON client helper */
export const upload = async (wsId, file, meta = {}) => {
  const form = new FormData();
  form.append('file', file);
  if (meta.personId)  form.append('personId',  meta.personId);
  if (meta.companyId) form.append('companyId', meta.companyId);
  if (meta.dealId)    form.append('dealId',    meta.dealId);
  if (meta.taskId)    form.append('taskId',    meta.taskId);
  if (meta.noteId)    form.append('noteId',    meta.noteId);

  const headers = {};
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`/api/v1${base(wsId)}/upload`, { method: 'POST', headers, body: form });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Upload failed (${res.status})`);
  }
  return res.json();
};
